import { SUPPORT_FEATURE } from "api/ApiPath";
import { BaseApiResponseModel } from "api/baseApiResponseModel/BaseApiResponseModel";
import { ListBaseApiResponseModel } from "api/baseApiResponseModel/ListBaseApiResponseModel";
import client from "api/client";
import { injectable } from "tsyringe";
import { ApiDocumentRequestModel } from "./model/apiDocument/ApiDocumentRequestModel";
import { ApiDocumentResponseModel } from "./model/apiDocument/ApiDocumentResponseModel";
import { PackageLookupRequestModel } from "./model/packageLookup/PackageLookupRequestModel";
import { PackageLookupResponseModel } from "./model/packageLookup/PackageLookupResponseModel";
import { SimLookupRequestModel } from "./model/simLookup/SimLookupRequestModel";
import { SimLookupResponseModel } from "./model/simLookup/SimLookupResponseModel";

export interface ISupportFeatureRepository {
  viewPlan(
    params: PackageLookupRequestModel
  ): Promise<BaseApiResponseModel<PackageLookupResponseModel>>;
  viewSim(
    params: SimLookupRequestModel
  ): Promise<BaseApiResponseModel<SimLookupResponseModel>>;
  viewDocument(
    params: ApiDocumentRequestModel
  ): Promise<ListBaseApiResponseModel<ApiDocumentResponseModel>>;
  viewOfficialDispatch(
    params: ApiDocumentRequestModel
  ): Promise<ListBaseApiResponseModel<ApiDocumentResponseModel>>;
}

@injectable()
export class SupportFeatureImpl implements ISupportFeatureRepository {
  async viewPlan(
    params: PackageLookupRequestModel
  ): Promise<BaseApiResponseModel<PackageLookupResponseModel>> {
    return await client?.get(SUPPORT_FEATURE.VIEW_PLAN, params);
  }

  async viewSim(
    params: SimLookupRequestModel
  ): Promise<BaseApiResponseModel<SimLookupResponseModel>> {
    return await client?.get(SUPPORT_FEATURE.VIEW_SIM, params);
  }

  async viewDocument(
    params: ApiDocumentRequestModel
  ): Promise<ListBaseApiResponseModel<ApiDocumentResponseModel>> {
    return await client?.get(SUPPORT_FEATURE.API_DOCUMENT, params);
  }

  async viewOfficialDispatch(
    params: ApiDocumentRequestModel
  ): Promise<ListBaseApiResponseModel<ApiDocumentResponseModel>> {
    return await client?.get(SUPPORT_FEATURE.OFFICIAL_DISPATCH, params);
  }
}
